import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/sitemap.scss";
import { IoMdArrowBack } from "react-icons/io";

const Sitemap = () => {
  const navigate = useNavigate();
  return (
    <div className="sitemap_main">
      <div className="container">
        <div className="back_button">
          <span className="icon" onClick={() => navigate(-1)}>
            <IoMdArrowBack />
          </span>
          <span className="text">Sitemap</span>
        </div>
        <div className="sitemap_links">
          <div>
            <div>
              <h2>SSB GPT</h2>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/chat">Classrooms</Link>
                </li>
                <li>
                  <Link to="/about-us">About Us</Link>
                </li>
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>
                <li>
                  <Link to="/refund-cancellation-policy">Refund Policy</Link>
                </li>
                <li>
                  <Link to="/login">Login</Link>
                </li>
                <li>
                  <Link to="/register">Register</Link>
                </li>
                <li>
                  <Link to="/student-register">Student Register</Link>
                </li>
                <li>
                  <Link to="/teacher-register">Teacher Register</Link>
                </li>
                <li>
                  <Link to="/parent-register">Parent Register</Link>
                </li>
                <li>
                  <Link to="/forgot-password">Forgot Password</Link>
                </li>
                <li>
                  <Link to="/privacy-policies">Privacy Policies</Link>
                </li>
                <li>
                  <Link to="/term-of-use">Term Of Use</Link>
                </li>
              </ul>
              <br />
              <h2>Profiles</h2>
              <ul>
                <li>
                    <Link to="/profile/captain-alpha">Captain Alpha</Link>
                </li>
                <li>
                    <Link to="/profile/fitness-coach">Fitness Coach</Link>
                </li>
                <li>
                    <Link to="/profile/cpss-expert">CPSS Expert</Link>
                </li>
                <li>
                    <Link to="/profile/english-trainer">English Trainer</Link>
                </li>
                <li>
                    <Link to="/profile/medical-expert">Medical Expert</Link>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div>
              <h2>About</h2>
              <ul>
                <li>
                  <Link to="/ishihara-detail">Ishihara Test Details</Link>
                </li>
                <li>
                  <Link to="/more-about-eye-test">About Eye Test</Link>
                </li>
                <li>
                  <Link to="/about-push-ups">About Push Ups</Link>
                </li>
                <li>
                  <Link to="/about-body-squats">About Body Squats</Link>
                </li>
                <li>
                  <Link to="/about-reverse-lunges">About Reverse Lunges</Link>
                </li>
                <li>
                  <Link to="/about-mountain-climber">About Mountain Climber</Link>
                </li>
                <li>
                  <Link to="/about-knee-push-ups">About Knee Push Ups</Link>
                </li>
                <li>
                  <Link to="/about-burpee">About Burpee</Link>
                </li>
                <li>
                  <Link to="/about-calf-raises">About Calf Raises</Link>
                </li>
                <li>
                  <Link to="/about-calf-raises">About Calf Raises</Link>
                </li>
                <li>
                  <Link to="/about-crunch">About Crunch</Link>
                </li>
                <li>
                  <Link to="/about-glute-bridge">About Glute Bridge</Link>
                </li>
                <li>
                  <Link to="/about-jumping-jack">About Jumping Jack</Link>
                </li>
                <li>
                  <Link to="/about-leg-raises">About Leg Raises</Link>
                </li>
                <li>
                  <Link to="/about-step-up">About Step Up</Link>
                </li>
                <li>
                  <Link to="/about-tricep-dips">About Tricep Dips</Link>
                </li>
                <li>
                  <Link to="/about-lunge">About Lunge</Link>
                </li>
                <li>
                  <Link to="/about-bicycle-crunches">About Bicycle Crunches</Link>
                </li>
                <li>
                  <Link to="/about-wall-sit">About Wall Sit</Link>
                </li>
                <li>
                  <Link to="/about-arm-circles">About Arm Circles</Link>
                </li>
                <li>
                  <Link to="/about-bear-crawl">About Bear Crawl</Link>
                </li>
                <li>
                  <Link to="/about-pull-ups">About Pull Ups</Link>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div>
              <h2>How To Use</h2>
              <ul>
                <li>
                  <Link to="/how-use-cpss-classroom">CPSS Classroom</Link>
                </li>
                <li>
                  <Link to="/how-use-spoken-en-classroom">Spoken English Classroom</Link>
                </li>
                <li>
                  <Link to="/how-use-olq-analyse-classroom">OLQ Analyse Classroom</Link>
                </li>
                <li>
                  <Link to="/how-use-ssb-mentor-classroom">ssb-mentor-classroom</Link>
                </li>
                <li>
                  <Link to="/how-use-mock-psychology-classroom">Mock Psychology Classroom</Link>
                </li>
                <li>
                  <Link to="/how-use-oir-classroom">OIR Classroom</Link>
                </li>
                <li>
                  <Link to="/how-use-physical-classroom">Physical Classroom</Link>
                </li>
                <li>
                  <Link to="/how-use-medical-classroom">Medical Classroom</Link>
                </li>
                <li>
                  <Link to="/how-use-group-discussion-classroom">Group Discussion Classroom</Link>
                </li>
                <li>
                  <Link to="/how-use-psychology-test-classroom">Psychology Test Classroom</Link>
                </li>
                <li>
                  <Link to="/how-use-ppdt-classroom">PPDT Classroom</Link>
                </li>
                <li>
                  <Link to="/how-use-gto-classroom">GTO Classroom</Link>
                </li>
                <li>
                  <Link to="/how-use-courses-classroom">Courses Classroom</Link>
                </li>
                <li>
                  <Link to="/how-use-mock-interview-classroom">Mock Interview Classroom</Link>
                </li>
                <li>
                  <Link to="/how-use-current-affairs-classroom">Current Affairs Classroom</Link>
                </li>
                <li>
                  <Link to="/how-use-notes-classroom">Notes</Link>
                </li>
                <li>
                  <Link to="/how-use-ssb-gpt">SSB GPT</Link>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div>
              <h2>Psychomotor Test</h2>
              <ul>
                <li>
                  <Link to="/memory-recall-test">Memory Recall Test</Link>
                </li>
                <li>
                  <Link to="/vigilance-test">Vigilance Test</Link>
                </li>
                <li>
                  <Link to="/dual-task-test">Dual Task Test</Link>
                </li>
                <li>
                  <Link to="/sensor-motor-test">Sensor Motor Test</Link>
                </li>
                <li>
                  <Link to="/dot-estimation-test">Dot Estimation Test</Link>
                </li>
                <li>
                  <Link to="/velocity-test">Velocity Test</Link>
                </li>
                <li>
                  <Link to="/speed-anticipation-test">Speed Anticipation Test</Link>
                </li>
                <li>
                  <Link to="/pursuit-tracking-test">Pursuit Tracking Test</Link>
                </li>
                <li>
                  <Link to="/size-anticipation-test">Size Anticipation Test</Link>
                </li>
                <li>
                  <Link to="/color-naming-test">Color Naming Test</Link>
                </li>
              </ul>
              <br />
              <h2>Page Instrunctions</h2>
              <ul>
                <li>
                    <Link to="/binaural-music">Binaural Music</Link>
                </li>
                <li>
                    <Link to="/notes-instructions">Notes</Link>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div>
              <h2>Useful Links</h2>
              <ul>
                <li>
                  <Link to="/ishihara-test">Ishihara Test</Link>
                </li>
                <li>
                  <Link to="/eye-test">Eye Test</Link>
                </li>
                {/* <li>
                  <Link to="/video">Video</Link>
                </li> */}
                <li>
                  <Link to="/interview">Interview</Link>
                </li>
                <li>
                  <Link to="/lecturette">Lecturette</Link>
                </li>
                <li>
                  <Link to="/feedback">Feedback</Link>
                </li>
                <li>
                  <Link to="/psychology-test-attempt">Psychology Test</Link>
                </li>
                {/* <li>
                  <Link to="/srt-practice-test">SRT Practice Test</Link>
                </li> */}
                <li>
                  <Link to="/spoken-english">Spoken English</Link>
                </li>
                <li>
                  <Link to="/mock-ppdt">Mock PPDT</Link>
                </li> 
              </ul>
            </div>
          </div>
          {/* <div>
            <div>
              <h2>Other GPTs</h2>
              <ul>
                <li>
                  <Link to="#!">NDA-GPT</Link>
                </li>
                <li>
                  <Link to="#!">CDS-GPT</Link>
                </li>
                <li>
                  <Link to="#!">INET-GPT</Link>
                </li>
                <li>
                  <Link to="#!">AFCAT-GPT</Link>
                </li>
            </ul>
            <br />
            <h2>Alpha Regiment</h2>
            <ul>
                <li>
                    <Link rel="nofollow noopener" target="_blank" to="https://alpharegiment.in/alpha-school">School Partner</Link>
                </li>
                <li>
                    <Link rel="nofollow noopener" target="_blank" to="https://alpharegiment.in/franchise/home">Franchisee</Link>
                </li>
                <li>
                    <Link rel="nofollow noopener" target="_blank" to="https://alpharegiment.in/cyber-partner">Cyber Partner</Link>
                </li>
            </ul>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Sitemap;
